/* eslint-disable */
import BannerInput from './BannerInput';

export default BannerInput;
